export default "__VITE_ASSET__BZDiT99v__"